
document.addEventListener('DOMContentLoaded', function() {
  const $container = $('.icon-container')
  $container.on('mouseover mouseout', function (e) {
    showDescription(this)
  })

  const scrollFormBtn = document.querySelector('.scroll-form-btn');
  if (scrollFormBtn) {
    scrollFormBtn.addEventListener('click', function() {
      if (!document.getElementById('contact_form').classList.contains('in')) {
        const demoButton = document.getElementById('demo-button');
        const navbar = document.querySelector('.navbar');
        const contactFormTop = document.getElementById('contact-form-top');
        
        const scrollTop = demoButton.offsetTop -
          (navbar ? navbar.offsetHeight : 0) -
          (contactFormTop ? contactFormTop.offsetHeight : 0);
        
        window.scrollTo({
          top: scrollTop,
          behavior: 'smooth'
        });
      }
    });
  }
});
function scrollForm () {
  if(!$('#contact_form').hasClass('in')) {
    $('html, body').animate({
      scrollTop: $('#demo-button').offset().top - $('.navbar').height() - $('#contact-form-top').height()
    }, 500);
  }
}

function setSize (parent, title, text) {
  const height = $(parent).height()
  const width = $(parent).width() - 10
  if (width > text.width()) {
    text.width(width)
  }
  text.height(height)

}

const toggleDescription = (parent) => {
  const title = $(parent).find('.icon-title')
  const text = $(parent).find('.icon-text')
  setSize(parent, title, text)

  text.toggleClass('hidden-text table-centered')
  title.toggleClass('show hidden-text')

}

const showDescription = (parent) => {

  const text = $(parent).find('.icon-text')
  const title = $(parent).find('.icon-title')
  setSize(parent, title, text)
  if ($(window).width() < 767)
    return

  const textVisible = text.hasClass('table-centered')

  $('.icon-title').switchClass('hidden-text', 'show', 0)
  $('.icon-text').switchClass('table-centered', 'hidden-text', 0)

  if (textVisible) {
    text.removeClass('table-centered').addClass('hidden-text')
    title.removeClass('hidden-text').addClass('show')
  } else {
    text.removeClass('hidden-text').addClass('table-centered')
    title.removeClass('show').addClass('hidden-text')

  }

}
